import { amplitudeTracker } from '../../lib/shared/amplitude-tracker';

function useAmplitude() {
    return {
        resetFromAmplitude: amplitudeTracker.reset,
        getDeviceId: amplitudeTracker.getDeviceId
    }
};

export {
    useAmplitude
};
